<template>
    <div class="description text-left">
        <Truncate>
            <HTMLContent :content="descriptionHtml" class="description__content" />
        </Truncate>

        <slot></slot>
    </div>
</template>

<script>
import Truncate from '@/components/utility/Truncate';
import HTMLContent from '@/components/html/HTMLContent';

export default {
    name: 'Description',
    components: {
        HTMLContent,
        Truncate
    },
    props: {
        descriptionHtml: String,
        truncate: { type: Boolean, default: true }
    }
};
</script>

<style scoped lang="scss">
.description {
    &__content {
        ::v-deep {
            h2,
            h3,
            h4 {
                padding: 20px 0;
                font-weight: bold;
                margin-bottom: 0;
                line-height: 1;
            }

            h2 {
                font-size: 20px;
            }

            h3 {
                font-size: 18px;
            }

            h4 {
                font-size: 16px;
                padding: 16px 0;
            }

            p {
                text-align: justify;
                margin-bottom: 10px;
                font-size: 1rem;

                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
}
</style>
